import { RoomTypeID } from '@kamernet/core/ApiClient/Kamernet';
import { parseRouteParamToEnum } from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

export const DEFAULT_CITY_OR_LISTING_TYPE_ID = RoomTypeID.Room;

export type ListingsSearchSitemapByListingTypeIDRouteParams = {
  citySlugOrListingTypeID: RoomTypeID;
};

export type ListingsSearchSitemapByListingTypeIDRouteParamsString = {
  citySlugOrListingTypeID: string;
};

export const ListingsSearchSitemapByListingTypeID = defineRoute<
  ListingsSearchSitemapByListingTypeIDRouteParams,
  ListingsSearchSitemapByListingTypeIDRouteParamsString
>({
  pathname: '/sitemap/[citySlugOrListingTypeID]', // for this route [citySlugOrListingTypeID] means `ListingTypeID`
  routeParamsStringifier: routeParams => {
    return {
      citySlugOrListingTypeID: routeParams.citySlugOrListingTypeID.toString(),
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      citySlugOrListingTypeID:
        parseRouteParamToEnum(
          routeParamsString.citySlugOrListingTypeID,
          RoomTypeID,
        ) ?? DEFAULT_CITY_OR_LISTING_TYPE_ID,
    };
  },
});
